/**
 * 门户页面浏览埋点
 * POST /api/portal/pageview
 * Body: { path, referrer, dwellMs, visitorId, sessionId, eventType }
 */

const PAGEVIEW_URL = '/api/portal/pageview'
const VISITOR_KEY = 'zg.portal.visitorId'
const SESSION_KEY = 'zg.portal.sessionId'
const SESSION_AT_KEY = 'zg.portal.sessionAt'
const IDLE_MS = 30 * 60 * 1000

function randomId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '')
  }
  const bytes =
    typeof crypto !== 'undefined' && crypto.getRandomValues
      ? crypto.getRandomValues(new Uint8Array(16))
      : Array.from({ length: 16 }, () => Math.floor(Math.random() * 256))
  return Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
}

function visitorId() {
  let id = ''
  try {
    id = localStorage.getItem(VISITOR_KEY) || ''
  } catch {
    id = ''
  }
  if (!id || id.length < 8) {
    id = randomId()
    try {
      localStorage.setItem(VISITOR_KEY, id)
    } catch {
      /* ignore */
    }
  }
  return id
}

function sessionId() {
  const now = Date.now()
  let last = 0
  let id = ''
  try {
    last = Number(sessionStorage.getItem(SESSION_AT_KEY) || 0)
    id = sessionStorage.getItem(SESSION_KEY) || ''
  } catch {
    last = 0
    id = ''
  }
  if (!id || now - last > IDLE_MS) {
    id = randomId()
    try {
      sessionStorage.setItem(SESSION_KEY, id)
    } catch {
      /* ignore */
    }
  }
  try {
    sessionStorage.setItem(SESSION_AT_KEY, String(now))
  } catch {
    /* ignore */
  }
  return id
}

function safePath(raw) {
  const s = String(raw || '')
  if (s.length > 512) return ''
  const pathname = s.split(/[?#]/)[0]
  if (!pathname.startsWith('/') || pathname.startsWith('//')) return ''
  if (/[\\\0]/.test(pathname)) return ''
  if (/(^|\/)\.\.(\/|$)/.test(pathname)) return ''
  if (/%2e%2e|%5c|%00/i.test(pathname)) return ''
  return s
}

function report({ path, referrer, dwellMs, eventType }) {
  const p = safePath(path)
  if (!p) return

  const body = JSON.stringify({
    path: p,
    referrer: referrer || document.referrer || '',
    dwellMs: Math.max(0, dwellMs || 0),
    visitorId: visitorId(),
    sessionId: sessionId(),
    eventType
  })
  const blob = new Blob([body], { type: 'application/json' })
  if (navigator.sendBeacon) {
    navigator.sendBeacon(PAGEVIEW_URL, blob)
    return
  }
  fetch(PAGEVIEW_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true
  }).catch(() => {})
}

let enteredAt = Date.now()
let currentPath = location.pathname + location.search

function enter(path) {
  currentPath = path
  enteredAt = Date.now()
  report({ path, dwellMs: 0, eventType: 'PAGE_ENTER' })
}

function leave(path) {
  report({
    path,
    dwellMs: Date.now() - enteredAt,
    eventType: 'PAGE_LEAVE'
  })
}

/**
 * SPA 路由切换：离开上一页上报停留，进入新页立刻计 PV
 * @param {import('vue-router').Router} router
 */
export function bindPageviewTracking(router) {
  const initial =
    router.currentRoute.value?.fullPath ||
    router.currentRoute.value?.path ||
    currentPath
  enter(initial)

  router.afterEach((to, from) => {
    if (from && from.fullPath) leave(from.fullPath)
    enter(to.fullPath || to.path || '')
  })

  window.addEventListener('pagehide', () => leave(currentPath))
}
